import dayjs from "dayjs";

const LS_KEY = "app_date_format";

// Module-level format — initialized from localStorage, synced from DB on load
let _format: string = localStorage.getItem(LS_KEY) ?? "DD/MM/YYYY";

export function setDateFormat(format: string) {
  _format = format;
  localStorage.setItem(LS_KEY, format);
}

export function getDateFormat(): string {
  return _format;
}

/** Format a date value using the globally configured date format. */
export function formatDate(date: string | Date | null | undefined): string {
  if (!date) return "—";
  const d = dayjs(date);
  return d.isValid() ? d.format(_format) : "—";
}

/** Format a date+time value — date uses global format, time appended as hh:mm A. */
export function formatDateTime(date: string | Date | null | undefined): string {
  if (!date) return "—";
  const d = dayjs(date);
  return d.isValid() ? d.format(`${_format}, hh:mm A`) : "—";
}
